import * as React from 'react';
import MuiCircularProgress from '@mui/material/CircularProgress';
import { ICircularProgressProps } from './circular-progress-props';

export const CircularProgress: React.FunctionComponent<ICircularProgressProps> = ({ children, ...props }) => <MuiCircularProgress {...props}>{children}</MuiCircularProgress>;
